module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/home-front-service-lvl2-50.be47a84d.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/home-front-service-lvl2-50.png
// module id = 3538
// module chunks = 11